import { render, staticRenderFns } from "./NonButtonUpdateSortModal.vue?vue&type=template&id=74834b9a&scoped=true"
import script from "./NonButtonUpdateSortModal.vue?vue&type=script&lang=js"
export * from "./NonButtonUpdateSortModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74834b9a",
  null
  
)

export default component.exports